import { OutputSelector } from 'reselect';


function createSelectorCreatorPack<R>(createReselectSelector: R) {
	type AsyncSelectorConfig<T, S> = {
		get: (s: S) => any;
		selector: OutputSelector<S, T, Function>;
	}
	
	function createAsyncSelector<T, S>(config: AsyncSelectorConfig<T, S>) {
		return {
			selectItem: config.selector,
			selectIsFetching: (state: S) => config.get(state).isFetching,
			selectIsLoaded: (state: S) => config.get(state).isLoaded,
			selectDidInvalidate: (state: S) => config.get(state).didInvalidate,
		};
	}

	return {
		createSelector: createReselectSelector,
		createAsyncSelector,
	}
}

export default createSelectorCreatorPack;
